import { defineDocument, em, link, p, section, strong, table, text, } from '../../schema';
export const featureAchievementsDocument = defineDocument({
    id: 'feature:achievements',
    kind: 'feature',
    slug: 'achievements',
    route: '/discover/features/achievements',
    seo: {
        title: 'Discover Achievements',
        description: 'Earn rewards with Airhead Games achievements. Learn how levels work, which achievements are live, and how past activity counts toward new achievements.',
    },
    hero: {
        eyebrow: [text('Discover Feature')],
        title: [text('Achievements')],
        description: [
            text('Earn rewards with Airhead Games achievements. Learn how levels work, which achievements are live, and how past activity counts toward new achievements.'),
        ],
    },
    aside: {
        showToc: true,
    },
    sections: [
        section({
            id: 'overview',
            title: 'Achievements Overview',
            sections: [
                section({
                    id: 'overview__what-are-achievements',
                    title: 'What Are Achievements?',
                    blocks: [
                        p([
                            text('Achievements reward you for things you do on Airhead Games, such as hosting games and connecting your Twitch account. Open '),
                            link('/library/achievements', 'Achievements'),
                            text(' in the sidebar of the Game Library to see every achievement and your progress.'),
                        ]),
                        p([
                            text('You must be logged in to earn achievements. If you are not signed in, the page will list every achievement as unearned.'),
                        ]),
                    ],
                }),
                section({
                    id: 'overview__how-achievements-work',
                    title: 'How Achievements Work',
                    blocks: [
                        p([
                            text('Each achievement has one or more levels. A level has a goal, such as '),
                            em('Host 4 games'),
                            text(', plus an associated reward for completing it. A one-time achievement has a single level. Earned levels are permanent.'),
                        ]),
                        p([
                            text('Rewards might include things like Loons or special access and go into effect immediately after the achievement is completed. To see the levels you have earned and when, select the info icon on an achievement card. If a reward granted you Loons, you can also see it in your '),
                            link('/library?dialog=loon-history', 'Loon history'),
                            text(' transaction records.'),
                        ]),
                        p([
                            text('When you reach a new milestone for an achievement, a celebration will show the next time you enter the Game Library. Press '),
                            em('Collect'),
                            text(' to close it.'),
                        ]),
                    ],
                }),
                section({
                    id: 'overview__past-activity',
                    title: 'Credit for Past Activity',
                    blocks: [
                        p([
                            text('We will keep adding new achievements. The ones you would have reached had they existed at the time will automatically be credited to your account. You receive the reward for every level you have already reached.'),
                        ]),
                        p([
                            text('Levels credited this way do not show a celebration. Their earned date is the day the credit was given, typically at release of the achievement, not the historical date the achievement would have been reached.'),
                        ]),
                    ],
                }),
            ],
        }),
        section({
            id: 'current-achievements',
            title: 'Current Achievements',
            blocks: [
                p([text('All hosting achievements count only games that finish.')]),
                // Titles and descriptions are hand-copied from backend/src/services/
                // achievements/achievementDefinitions.ts, which shared cannot import.
                // Update this table when a track or its milestones change there.
                table({
                    columns: ['Achievement', 'Description', 'Levels'],
                    rows: [
                        [
                            [strong('Hello, Chat')],
                            [
                                text('Connect your '),
                                link('/discover/features/login#link-twitch-later', 'Twitch account'),
                                text(' to Airhead Games.'),
                            ],
                            '1',
                        ],
                        [
                            [strong('Party Starter')],
                            'Host games that play all the way to the end.',
                            '10',
                        ],
                        [
                            [strong('Mood Swings')],
                            [
                                text('Host games in every '),
                                link('/discover/features/user-preferences#content-style', 'content style'),
                                text('.'),
                            ],
                            '1',
                        ],
                        [[strong('Full House')], 'Host games with many players.', '4'],
                    ],
                }),
            ],
        }),
    ],
});
//# sourceMappingURL=achievements.js.map